export default __webpack_public_path__ + "static/media/gamer-claiming.8eef29f3.png";